import { Alert, Box, Divider, Typography } from '@mui/material';
import { Loading, SmallLoader } from 'framework/ui/mui-builder';
import { ComplianceCoverageEmployee } from './types';
import ComplianceAudienceCoverageStatusCell from './ComplianceAudienceCoverageStatusCell';

type ComplianceAudienceCoverageContentProps = {
  loading: boolean;
  isLoadingMore: boolean;
  coverageEntries: ComplianceCoverageEmployee[];
  showStatuses: boolean;
  infoMessage?: string;
};

const ComplianceAudienceCoverageContent = ({
  loading,
  isLoadingMore,
  coverageEntries,
  showStatuses,
  infoMessage,
}: ComplianceAudienceCoverageContentProps) => {
  if (loading && !isLoadingMore) {
    return (
      <Box display="flex" justifyContent="center" py={4}>
        <Loading />
      </Box>
    );
  }

  if (!coverageEntries.length) {
    return <Alert severity="info">No records found</Alert>;
  }

  return (
    <>
      {infoMessage && (
        <Alert severity="info" sx={{ mb: 2 }}>
          {infoMessage}
        </Alert>
      )}

      {coverageEntries.map(({ employeeAlias, employeeFullName, status }) => {
        const employeeLabel = employeeFullName || employeeAlias;

        return (
          <Box key={employeeAlias}>
            <Box display="flex" justifyContent="space-between" alignItems="center" gap={2}>
              <Typography>{employeeLabel}</Typography>

              {showStatuses && <ComplianceAudienceCoverageStatusCell status={status} />}
            </Box>

            <Divider sx={{ mt: 1.5 }} />
          </Box>
        );
      })}

      {isLoadingMore && (
        <Box display="flex" justifyContent="center" pt={1.5} pb={0.5}>
          <SmallLoader />
        </Box>
      )}
    </>
  );
};

export default ComplianceAudienceCoverageContent;
